/**
 * @fileoverview Notes Management API Module
 * This module provides comprehensive API functions for managing notes and annotations
 * associated with various entities (members, providers, etc.) including:
 * - Fetching notes with search and filtering capabilities
 * - Adding new notes with entity association
 * - Editing existing notes with full content updates
 * - Entity-based note organization and retrieval
 * - Search functionality across note content and metadata
 */

import api from "./api";

export const fetchNotes = async (
  entityType,
  memberId,
  { searchQuery = "" } = {}
) => {
  try {
    const params = new URLSearchParams({
      entityType,
      entityId: memberId,
    });

    if (searchQuery && searchQuery.trim() !== "") {
      params.append("searchQuery", searchQuery.trim());
    }

    const response = await api.get(`/api/notes?${params.toString()}`, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });

    return response.data;
  } catch (e) {
    return "Error fetching notes: " + (e instanceof Error ? e.message : String(e));
  }
};

export const addNoteApi = async (memberId, payload) => {
  try {
    const response = await api.post(`/api/notes`, payload, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (e) {
    return "Error adding note: " + e.message;
  }
};

export const editNoteApi = async (noteId, payload) => {
  try {
    const response = await api.put(`/api/notes/${noteId}`, payload, {
      headers: {
        "Content-Type": "application/json",
        "ngrok-skip-browser-warning": "true",
      },
    });
    return response.data;
  } catch (e) {
    return "Error editing note: " + e.message;
  }
};
